import { render, staticRenderFns } from "./CourseTable.vue?vue&type=template&id=3d31c8e8&"
import script from "./CourseTable.vue?vue&type=script&lang=ts&"
export * from "./CourseTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports